<script>
import Breadcrumb from '@/components/global/breadcrumb.vue';
import InputText from 'primevue/inputtext';
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import axios from "axios";
import Swal from "sweetalert2";
import Dropdown from 'primevue/dropdown';
import { useGradeStore } from '@/stores/useGradeStore.js';

export default {
  name: "lessons",
  inject: {
    courseCtx: { default: null },
  },
  data() {
    return {
      v$: useVuelidate(),
      type: this.$route.params.type || this.$route.meta.type,
      gradeSlug: this.$route.params.gradeSlug,
      courseId: this.$route.params.courseId ?? null,
      title: "",
      description: "",
      imageEntry: "",
      // fileData: "",
      formSending: false,
      branch: null,
      branches: [],
      unit: null,
      units: [],
    };
  },
  components: {
    Breadcrumb,
    InputText,
    Dropdown
  },
  validations() {
    return {
      title: { required },
      // description: { required },
      // branch: { required },
    };
  },
  computed: {
    isCourseScope() { return !!this.courseId; },
    typeSegment() {
      switch (this.type) {
        case 'branch': return 'branches';
        case 'unit': return 'units';
        case 'lesson': return 'lessons';
        default: return '';
      }
    },
    basePath() {
      return this.isCourseScope
          ? `/courses/${this.courseId}/${this.typeSegment}`
          : `/${this.type}/${this.gradeSlug}`;
    },
    breadcrumbs() {
      if (this.isCourseScope) {
        const base = this.courseCtx?.breadcrumbBase ?? [];
        return [
          ...base,
          { name: this.typeLabel, path: this.basePath },
          { name: `أضافه ${this.typeLabel}`, path: `${this.basePath}/add` },
        ];
      }
      return [
        { name: 'الرئيسية', path: '/' },
        { name: this.typeLabel, path: `/${this.type}/${this.gradeSlug}` },
        { name: `أضافه ${this.typeLabel}`, path: `/${this.type}/${this.gradeSlug}/add` },
      ];
    },
    typeLabel() {
      switch (this.type) {
        case 'branch':
          return 'الفرع';
        case 'unit':
          return 'الوحدة';
        case 'lesson':
          return 'الدرس';
        default:
          return '';
      }
    },
    gradeStore() { return useGradeStore(); },
    resolvedGrade() {
      const slug = this.gradeSlug;
      return this.gradeStore.activeGrades.find(g => g.slug === slug)
          || this.gradeStore.allGrades.find(g => g.slug === slug)
          || null;
    },
    gradeId() {
      return this.resolvedGrade?.id ?? null;
    },
    typeNumber() {
      switch (this.type) {
        case 'branch':
          return 1;
        case 'unit':
          return 2;
        case 'lesson':
          return 3;
        default:
          return null;
      }
    }
  },
  methods: {
    // onFileChange(event) {
    //   this.fileData = event.target.files[0];
    //   const reader = new FileReader();
    //   reader.readAsDataURL(this.fileData);
    //   reader.onload = () => (this.imageEntry = reader.result);
    // },
    sendForm() {
      this.v$.$validate();
      if (!this.v$.$error) {
        const formData = new FormData();
        formData.append('title', this.title);
        formData.append('description', this.description);
        if (this.isCourseScope) {
          formData.append('course_id', this.courseId);
        } else {
          formData.append('academic_year_id', this.gradeId);
        }
        formData.append('type', this.typeNumber);
        // if (this.fileData) {
        //   formData.append('image', this.fileData);
        // }
        if (this.branch && this.typeNumber === 2) {
          formData.append('parent_id', this.branch.id);
        }
        if (this.unit && this.typeNumber === 3) {
          formData.append('parent_id', this.unit.id);
        }
        this.formSending = true;

        axios
            .post('/lessons', formData)
            .then((response) => {
              this.formSending = false;
              this.resetForm();
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تم الاضافه بنجاح",
              });
            })
            .catch((error) => {
              this.formSending = false;
              Swal.fire({
                position: "center",
                icon: "error",
                title: error.response.data.message,
              });
            });
      }
    },
    resetForm() {
      this.v$.$reset();
      this.title = "";
      this.description = "";
      this.imageEntry = "";
      // this.fileData = "";
    },
    fetchBranch() {
      const params = this.isCourseScope
          ? { type: 1, course_id: this.courseId }
          : { type: 1, academic_year_id: this.gradeId };
      axios
          .get('/lessons', { params })
          .then((response) => {
            this.branches = response.data.data;
          })
          .catch(() => {});
    },
    fetchUnits() {
      const branchId = this.branch.id;
      const params = this.isCourseScope
          ? { type: 2, course_id: this.courseId, parent_id: branchId }
          : { type: 2, academic_year_id: this.gradeId, parent_id: branchId };
      axios
          .get('/lessons', { params })
          .then((response) => {
            this.units = response.data.data;
          })
          .catch(() => {});
    },


    customLabelBranch(option) {
      return option ? `${option.title} (${option.description})` : '';
    },
    customLabelUnit(option) {
      return option ? `${option.title} (${option.description})` : '';
    },
    customLabelLesson(option) {
      return option ? `${option.title} (${option.description})` : '';
    },
  },
  async mounted() {
    if (!this.isCourseScope) {
      if (!this.gradeStore.activeGrades.length) await this.gradeStore.fetchActiveGrades();
      if (!this.gradeStore.allGrades.length) await this.gradeStore.fetchAllGrades();
    }
    if (this.typeNumber === 2 || this.typeNumber === 3) {
      this.fetchBranch();
    }
  }
}
</script>

<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="form-page">
    <div class="form-page-header">
      <div class="form-page-header__icon">
        <i :class="`pi ${typeNumber === 1 ? 'pi-sitemap' : typeNumber === 2 ? 'pi-folder' : 'pi-book'}`"></i>
      </div>
      <div class="form-page-header__text">
        <h1 class="form-page-header__title">إضافة {{ typeLabel }}</h1>
        <p class="form-page-header__subtitle">إضافة {{ typeLabel }} جديد للمنهج الدراسي</p>
      </div>
    </div>

    <div class="container-fluid">
      <form @submit.prevent="sendForm()">
        <div class="form-card" v-if="typeNumber >= 2">
          <div class="form-card__header">
            <div class="form-card__header-icon"><i class="pi pi-sitemap"></i></div>
            <span class="form-card__title">التسلسل الهرمي</span>
          </div>
          <div class="form-card__body">
            <div class="row g-4">
              <div class="col-lg-6 col-12">
                <div class="form-field">
                  <label class="field-label" for="branch">الفرع</label>
                  <Dropdown v-model="branch" :options="branches" showClear :optionLabel="customLabelBranch" placeholder="اختر الفرع" class="w-100" @update:model-value="fetchUnits" />
                </div>
              </div>
              <div class="col-lg-6 col-12" v-if="typeNumber === 3">
                <div class="form-field">
                  <label class="field-label" for="unit">الوحدة</label>
                  <Dropdown v-model="unit" :options="units" showClear :optionLabel="customLabelUnit" placeholder="اختر الوحدة" class="w-100" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-card">
          <div class="form-card__header">
            <div class="form-card__header-icon"><i class="pi pi-pencil"></i></div>
            <span class="form-card__title">تفاصيل {{ typeLabel }}</span>
          </div>
          <div class="form-card__body">
            <div class="row g-4">
              <div class="col-lg-6 col-12">
                <div class="form-field">
                  <label class="field-label" for="title">
                    اسم {{ typeLabel }} <span class="required">*</span>
                  </label>
                  <InputText id="title" v-model="title" :placeholder="`أدخل اسم ${typeLabel}`" class="w-100" />
                  <span class="field-error" v-if="v$.title.$error">
                    <i class="pi pi-exclamation-circle"></i> برجاء ادخال اسم {{ typeLabel }}
                  </span>
                </div>
              </div>
              <div class="col-lg-6 col-12">
                <div class="form-field">
                  <label class="field-label" for="description">
                    وصف {{ typeLabel }} <span class="optional">اختياري</span>
                  </label>
                  <InputText id="description" v-model="description" :placeholder="`أدخل وصف ${typeLabel}`" class="w-100" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <button type="submit" class="btn-submit" :disabled="formSending">
            <i class="pi pi-spin pi-spinner-dotted" v-if="formSending"></i>
            <i class="pi pi-check" v-else></i>
            {{ formSending ? 'جاري الإرسال...' : `حفظ ${typeLabel}` }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>